import request from '../helpers/request';

const updateRequestComment = async (data) => {
  return await request.put(
    `/Request/edit_note`,
    data,
    'Не удалось обновить комментарий'
  );
};

export default updateRequestComment;
